import { useState, useEffect } from 'react';

export const isStandaloneApp = () => {
  return window.matchMedia('(display-mode: standalone)').matches;
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      // Check both screen width and user agent
      const isMobileWidth = window.innerWidth <= 768; // Common mobile breakpoint
      const isMobileDevice =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );

      return isMobileWidth || isMobileDevice;
    };

    setIsMobile(checkIsMobile());

    const handleResize = () => setIsMobile(checkIsMobile());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};
